import api from "./client";

export interface StripeConnectStatus {
  connected: boolean;
  charges_enabled: boolean;
  payouts_enabled: boolean;
  details_submitted: boolean;
  ready: boolean;
  missing?: string[];
  code?: string;
}

export const getStripeConnectStatus = () => {
  return api.get<StripeConnectStatus>("/stripe/connect/status");
};

export const startStripeOnboarding = (payload?: { return_path?: string }) => {
  return api.post<{ url: string }>("/stripe/connect/onboard", payload ?? {});
};

export const getStripeDashboardLink = () => {
  return api.post<{ url: string }>("/stripe/connect/dashboard");
};
